import { CircularProgress, Stack } from '@mui/material';

export const CenteredLoadingSpinner = () => (
    <Stack
        direction="row"
        sx={{
            justifyContent: 'center',
            alignItems: 'center',
        }}
    >
        <CircularProgress data-testid="loading-spinner" sx={{ margin: '40px auto' }} />
    </Stack>
);
